// src/prompts/p01_cracks.js — Structural Cracks · ACI 224.1R

export const PROMPT_P01 = (sponsorProduct = 'Sikadur-52 LV + SikaTop-122 Plus') => `
Analyze this concrete image for STRUCTURAL CRACKS (ACI 224.1R).

Visual indicators to evaluate:
- Pattern: diagonal (shear), horizontal (bending), vertical (compression), map cracking (ASR/shrinkage), random (settlement)
- Estimated width: hairline <0.1mm, fine 0.1–0.3mm, medium 0.3–1mm, wide >1mm
- Location: beam, column, slab, wall, foundation (infer from context)
- Activity: active (rust staining, efflorescence at crack) vs. dormant (clean edges)
- Depth indicators: spalled edges, exposed rebar

Return ONLY this JSON:
{
  "pathology_id": "p01_cracks",
  "pathology_name": { "es": "Grietas estructurales", "en": "Structural cracks" },
  "norm": "ACI 224.1R",
  "confidence": 87,
  "requires_additional_input": false,
  "crack_pattern": "diagonal|horizontal|vertical|map_cracking|random|mixed",
  "estimated_width_mm": 0.4,
  "crack_activity": "active|dormant|unknown",
  "element_type": "beam|column|slab|wall|foundation|unknown",
  "root_cause": {
    "es": "Descripción técnica 2–3 oraciones en español",
    "en": "Technical description 2–3 sentences in English"
  },
  "severity": "low|medium|high|critical",
  "urgency": "deferred|planned|immediate|emergency",
  "repair": {
    "procedure": {
      "es": [
        "1. Mapeo y registro dimensional de grietas (ancho, longitud, patrón)",
        "2. Si ancho >0.3mm: inyección con resina epóxica de baja viscosidad (ACI 224.1R Sec. 3.4)",
        "3. Si ancho <0.3mm: sellado superficial con mortero elastomérico o lechada epóxica",
        "4. Si grieta es activa o afecta elemento portante: evaluación estructural por perito certificado"
      ],
      "en": [
        "1. Crack mapping and dimensional recording (width, length, pattern)",
        "2. If width >0.3mm: low-viscosity epoxy resin injection (ACI 224.1R Sec. 3.4)",
        "3. If width <0.3mm: surface sealing with elastomeric mortar or epoxy grout",
        "4. If crack is active or affects load-bearing element: assessment by certified structural inspector"
      ]
    },
    "norm_reference": "ACI 224.1R-07, Sections 3.2–3.5"
  },
  "materials": {
    "generic": {
      "es": "Resina epóxica de baja viscosidad para inyección; mortero de reparación con fibras",
      "en": "Low-viscosity epoxy resin for injection; fiber-reinforced repair mortar"
    },
    "premium": {
      "product": "${sponsorProduct}",
      "brand": "Sika",
      "note": {
        "es": "Sikadur-52 LV cumple ASTM C881 Tipo I y IV. Resistencia a compresión >70 MPa.",
        "en": "Sikadur-52 LV complies with ASTM C881 Type I & IV. Compressive strength >70 MPa."
      }
    }
  },
  "linkedin_draft": {
    "es": "Post LinkedIn primera persona como Arq. Eugenio Carrasco. Menciona ConcrePro. Tono técnico-divulgativo. Máximo 1300 chars. Termina con pregunta. #ConcrePro #PatologíaDelConcreto #ICRI #ACI #Sika + 2 hashtags más"
  },
  "disclaimer": {
    "es": "Diagnóstico asistido por IA. Debe ser validado por perito certificado antes de cualquier intervención estructural.",
    "en": "AI-assisted diagnosis. Must be validated by a certified inspector before any structural intervention."
  }
}`;
